import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import { Menu01Icon } from "@/components/Icons/Menu01Icon";
import { cardSurfaceVariants } from "@/design-system/Card";
import { Inline } from "@/design-system/Inline";
import { Spread } from "@/design-system/Spread";
import { SortableTransform, useSortable } from "@/ui-adapters/DndKit";

interface Props {
  id: string;
  title?: string;
  disabled?: boolean;
  children: ReactNode;
  headerActions?: ReactNode;
}
export function DynamicRepeaterItem({ id, title, disabled, children, headerActions }: Props): React.ReactNode {
  const { attributes, listeners, active, isDragging, setNodeRef, transform, transition } = useSortable({
    id: id,
    disabled: disabled,
  });
  let dragCursorClass: string | undefined;
  if (!disabled) {
    dragCursorClass = isDragging ? "cursor-grabbing" : "cursor-grab";
  }

  return (
    <SortableTransform
      className={twJoin(
        "relative flex cursor-default flex-col gap-space-md p-space-md",
        cardSurfaceVariants(),
        active && !isDragging && "shadow-raised",
      )}
      ref={setNodeRef}
      transform={transform}
      transition={transition}
    >
      {isDragging && <div className="absolute top-0 left-0 z-raised size-full rounded-xl bg-background-brand-light" />}
      <Spread space="sm">
        {title && <span className="text-body-emphasis">{title}</span>}
        <Inline gap="md" align="center" wrap={false}>
          <span {...attributes} {...listeners} className={twJoin("shrink-0 text-text-secondary", dragCursorClass)}>
            <Menu01Icon />
          </span>
          {headerActions}
        </Inline>
      </Spread>
      {children}
    </SortableTransform>
  );
}
